/**
 * @module getAPIBase
 */

/**
 * @typedef {object} MgnlEnvVars
 * @property {string} REACT_APP_MGNL_BASE_AUTHOR - Magnolia Author base path (e.g. '').
 * @property {string} REACT_APP_MGNL_BASE_PUBLIC - Magnolia Public base path (e.g. '').
 * @property {string} REACT_APP_MGNL_IS_PREVIEW - Boolean flag denoting whether or not the Magnolia environment is in preview mode.
 */

/**
 * Convenience function to return the Magnolia URL based as determined by process.env values.
 *
 * @param {MgnlEnvVars} mgnlEnvVars - Object of required Magnolia ENV variables. If not set, defaults and attempts to use `process.env`.
 *
 * @returns {string} The Magnolia URL base value.
 */
function getMgnlBase(mgnlEnvVars) {
  const envVars = mgnlEnvVars || process.env;
  let returnBase = '';
  if (envVars.REACT_APP_MGNL_IS_PREVIEW) {
    returnBase = envVars.REACT_APP_MGNL_BASE_AUTHOR;
  } else {
    returnBase = envVars.REACT_APP_MGNL_BASE_PUBLIC;
  }
  return returnBase;
}

module.exports = {
  getMgnlBase,
};
